<div class="my-3 my-md-5 border rounded-3 shadow bg-light">
  <div class="row p-4 justify-content-center">
    <div class="d-none d-lg-block col-12 col-sm-8 col-md-6 col-lg-4 col-xl-3">
      <nz-ad-card
        [data]="firstMockAdCardData"
        [disabledPreview]="true"
        [disabledLikeButton]="true"
        [disabledPreviewImages]="true">
      </nz-ad-card>
    </div>
    <div class="col-12 col-sm-8 col-md-6 col-lg-4 col-xl-3">
      <nz-ad-card
        [data]="adCardData"
        [bordered]="true"
        [disabledPreview]="true"
        [disabledLikeButton]="true"
        [disabledPreviewImages]="true">
      </nz-ad-card>
    </div>
    <div class="d-none d-lg-block col-12 col-sm-8 col-md-6 col-lg-4 col-xl-3">
      <nz-ad-card
        [data]="secondMockAdCardData"
        [disabledPreview]="true"
        [disabledLikeButton]="true"
        [disabledPreviewImages]="true">
      </nz-ad-card>
    </div>
  </div>
</div>
